import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#A3A3A3"
      fillRule="evenodd"
      d="m1.702 1.225.006.006 3.635 3.547c.355.346.554.82.554 1.315v3.898a.6.6 0 0 1-1.2 0V6.093a.64.64 0 0 0-.192-.456L.87 2.09C.088 1.327.628 0 1.72 0h10.562c1.093 0 1.633 1.328.85 2.09l-3.64 3.547a.64.64 0 0 0-.191.456v5.634a.6.6 0 0 1-1.2 0V6.093c0-.495.2-.97.554-1.315l3.64-3.547.005-.006.001-.002-.002-.012-.007-.01h-.002l-.008-.001H1.71l-.006.011-.003.012.001.002Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
